<template>
    <div
        class="el-checkbox-group"
        :class="{ 'is-invalid': isInvalid }"
        role="group"
        :aria-labelledby="`checkbox-group-label-${props.id}`"
        :aria-invalid="isInvalid || null"
    >
        <div class="el-checkbox-group__content">
            <slot />
        </div>
    </div>
</template>

<script setup>
import { computed, provide, inject, watch } from 'vue';

const emit = defineEmits(['update:modelValue', 'change']);

const props = defineProps({
    id: { type: String, default: '' },
    modelValue: { type: Array, default: () => [] },
    disabled: { type: Boolean, default: false },
    min: { type: Number, default: undefined },
    max: { type: Number, default: undefined },
});

const elFormItem = inject('elFormItem', null);
const isInvalid = computed(() => elFormItem?.validateState?.value === 'error');

function updateModelValue(val) {
    emit('update:modelValue', val);
}

function emitChange(val) {
    emit('change', val);
}

watch(() => props.modelValue, () => {
    elFormItem?.markAsTouched?.();
    elFormItem?.validate?.('change');
});



provide('checkboxGroup', {
    modelValue: computed(() => props.modelValue),
    disabled: computed(() => props.disabled),
    min: props.min,
    max: props.max,
    updateModelValue,
    emitChange,
    elFormItem,
});
</script>

<style lang="postcss" scoped>
.el-checkbox-group {
    display: flex;
    width: 100%;
    &__content {
        display: flex;
        gap: 16px;
    }
    &.is-invalid {
        position: relative;
        display: flex;
        padding: 0 8px;
        &:after {
            content: "";
            display: block;
            border: 1px solid var(--av-fixed-danger);
            border-radius: 4px;
            position: absolute;
            top: 0;
            bottom: 0;
            left: 0;
            right: 0;
            pointer-events: none;
        }
    }
}
</style>
